/**
 * Created by stonewang on 2017/8/2.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {hashHistory} from 'react-router';
import './menus.css'
import {Menu, Icon, Button} from 'antd';

const SubMenu = Menu.SubMenu;

class Menus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}'),
            thirdId: window.localStorage.getItem('thirdId') ? this.encrypt(JSON.parse(window.localStorage.getItem('thirdId'))) : '',
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        };
    }

    goView = ({item, key, keyPath}) => {
        if (key === 'system' && this.props.collapsed) {

        } else {
            (key !== 'system') && hashHistory.push(`/${key}`);
        }
    };

    encrypt(_a) {
        if (!_a) return '';
        var _s = "";
        for (var i = 0; i < _a.toString().length; i++) {
            _s = _s + String.fromCharCode((_a.toString()[i].charCodeAt() - 2));
        }
        return window.btoa(_s);
    }


    componentDidMount() {
    }


    render() {
        const {button_limits_end, thirdId} = this.state;
        const {defaultSelectedKeys} = this.props;
        return <Menu mode="inline"
                     onClick={this.goView}
                     className="dms-menu"
                     defaultSelectedKeys={defaultSelectedKeys}>
            {button_limits_end.home && <Menu.Item key="home" style={{background: '#efefef'}}>
                <Icon type='home'></Icon> <span>首页</span>
            </Menu.Item>
            }

            {button_limits_end.channelFunc && <SubMenu key="channel" title={<span>
        <Icon type='solution'></Icon><span>公告帮助</span></span>}>
                {button_limits_end.carousel && <Menu.Item key="carousel">广告发布管理</Menu.Item>}
                {button_limits_end.channelFunc1 && <Menu.Item key="channelFunc">资讯管理</Menu.Item>}
                {button_limits_end.infoRead && <Menu.Item key="infoRead">公告</Menu.Item>}
                {button_limits_end.info && <Menu.Item key="info"><span>帮助</span></Menu.Item>}
            </SubMenu>
            }

            {button_limits_end.financing &&
                <SubMenu key="financing" title={<span><Icon type="global"/><span>供应链融资</span></span>}>
                    <Menu.Item key="financing/zsbank">浙商银行</Menu.Item>
                </SubMenu>}

            {button_limits_end.systemA && <SubMenu key="systemA" title={<span>
              <Icon type='team'></Icon><span>客户管理</span>
            </span>
            }>
                {button_limits_end.customerManagement && <Menu.Item key="customerManagement">客户管理</Menu.Item>}
                {button_limits_end.purchaseUnit && <Menu.Item key="purchaseUnit">购货单位</Menu.Item>}
                {button_limits_end.creditChange && <Menu.Item key="creditChange">授信变动情况</Menu.Item>}
            </SubMenu>
            }

            {button_limits_end.merchandise && <SubMenu key="merchandise" title={<span>
            <Icon type="share-alt"/><span>商品管理</span>
          </span>
            }>
                {button_limits_end.merchandise && <Menu.Item key="merchandise"> <span>商品管理</span> </Menu.Item>}
                {button_limits_end.mallHome && <Menu.Item key="mallHome">商品选型 </Menu.Item>}
            </SubMenu>
            }

            {button_limits_end.product && <SubMenu key="product" title={<span>
            <Icon type='api'></Icon><span>产品管理</span>
          </span>
            }>
                {button_limits_end.product && <Menu.Item key="product">产品管理</Menu.Item>}
                {button_limits_end.shoppingCar && <Menu.Item key="shoppingCar"> 购物车 </Menu.Item>}
                {button_limits_end.favorites && <Menu.Item key="favorites"> 我的收藏 </Menu.Item>}
                {button_limits_end.inventoryQuery && <Menu.Item key="inventoryQuery"> 天正库存查询 </Menu.Item>}
                {button_limits_end.inventoryQuery && <Menu.Item key="scheduleList"> 天正交期查询 </Menu.Item>}
                {button_limits_end.mallHome && <Menu.Item key="mallHome">商品选型 </Menu.Item>}
            </SubMenu>
            }

            {button_limits_end.order && <SubMenu key="order" title={<span>
            <Icon type='shop'></Icon><span>订单管理</span>
          </span>
            }>
                {button_limits_end.PurchaseOrder && <Menu.Item key="order">采购订单</Menu.Item>}
                {button_limits_end.PurchaseOrder && <Menu.Item key="specialPriceQuery">特价查询</Menu.Item>}
                {button_limits_end.orderTrackQuery && <Menu.Item key="orderTrackQuery">未发跟踪</Menu.Item>}
                {button_limits_end.traceOrder && <Menu.Item key="traceOrder"> 追溯订单 </Menu.Item>}
                {button_limits_end.specialOrder && <Menu.Item key="specialOrder"> 特殊订单 </Menu.Item>}
                {button_limits_end.customOrder && <Menu.Item key="customOrder">定制订单 </Menu.Item>}
                {button_limits_end.preOrder && <Menu.Item key="preOrder">预订单 </Menu.Item>}
                {button_limits_end.owning && <Menu.Item key="owning">欠货查询 </Menu.Item>}
                {button_limits_end.delivery && <Menu.Item key="delivery">发货查询 </Menu.Item>}
                {button_limits_end.receiving && <Menu.Item key="receiving">收货确认 </Menu.Item>}
                {button_limits_end.secondShip && <Menu.Item key="transportSplit">二次配送 </Menu.Item>}
            </SubMenu>
            }

            {button_limits_end.productEn && <Menu.Item key="productEn" style={{background: '#efefef'}}>
                <Icon type='file-text'></Icon> <span>Price Query</span>
            </Menu.Item>
            }

            {button_limits_end.quotation && <Menu.Item key="quotation" style={{background: '#efefef'}}>
                <Icon type='file-text'></Icon> <span>报价单</span>
            </Menu.Item>
            }
            {button_limits_end.batchAccept && <Menu.Item key="batchAccept" style={{background: '#efefef'}}>
                <Icon type='book'></Icon> <span>分批签收</span>
            </Menu.Item>
            }

            {button_limits_end.financialManagement && <SubMenu key="financialManagement" title={<span>
            <Icon type='bank'></Icon><span>财务管理</span>
          </span>
            }>
                {button_limits_end.invoiceManagement && <Menu.Item key="invoiceManagement">开票管理</Menu.Item>}
                {button_limits_end.invoiceManagement && <Menu.Item key="invoiceItemMap">开票物料维护</Menu.Item>}
                {button_limits_end.invoiceManagement && <Menu.Item key="deliveryInvoicelist">发票台账</Menu.Item>}
                {button_limits_end.rebateBillManage && <Menu.Item key="rebateBillManage">结算单管理</Menu.Item>}
                {button_limits_end.rebateBillDetail && <Menu.Item key="settleDetailQuery">结算明细报表</Menu.Item>}
                {button_limits_end.invoiceManagement_01 && <Menu.Item key="home">
                    <a href={'https://tgdev.tengen.com.cn/admin/main/main?user=' + 'X2xtbHdrbXNx' + "&pwd=" + 'cmUvMDEyMzQ' + "&customer_id=" + thirdId}
                       target="_blank">网上对账</a>
                </Menu.Item>}
            </SubMenu>
            }

            {button_limits_end.returnGoods && <Menu.Item key="returnGoods" style={{background: '#efefef'}}>
                <Icon type='switcher'></Icon><span>退货管理</span>
            </Menu.Item>
            }

            {button_limits_end.escrowOrder &&
                <SubMenu key="escrowOrder" title={<span><Icon type='shop'></Icon><span>托管订单</span></span>}>
                    {button_limits_end.escrowOrderShip && <Menu.Item key="shipRequestQuery">发货请求</Menu.Item>}
                    {button_limits_end.escrowOrderPrint && <Menu.Item key="shipRequestHistory">单据打印</Menu.Item>}
                    {button_limits_end.escrowOrderReceipt && <Menu.Item key="waitReceiptQuery">接收入库</Menu.Item>}
                    {button_limits_end.escrowOrderOnhand && <Menu.Item key="onhandQuery">库存查询</Menu.Item>}
                    {button_limits_end.escrowOrderTransaction &&
                        <Menu.Item key="transactionQuery">出入库查询</Menu.Item>}
                    {button_limits_end.escrowOrderOnhand && <Menu.Item key="escrowDetailQuery">在途查询</Menu.Item>}
                </SubMenu>
            }

            {button_limits_end.report && <Menu.Item key="report" style={{background: '#efefef'}}>
                <Icon type='pie-chart'></Icon><span>分析报表</span>
            </Menu.Item>
            }

            {button_limits_end.reportForm && <SubMenu key="reportForm" title={<span>
              <Icon type='area-chart'></Icon><span>统计报表</span>
            </span>
            }>
                {button_limits_end.discountedReport && <Menu.Item key="discountedReport">发运含折让报表</Menu.Item>}
                {button_limits_end.discountStatements && <Menu.Item key="discountStatements">开单含折让报表</Menu.Item>}
                {button_limits_end.returnGoodsReport && <Menu.Item key="detailReport">退货明细报表</Menu.Item>}
                {button_limits_end.customerReceivableInquiry &&
                    <Menu.Item key="customerReceivableInquiry">客户应收查询</Menu.Item>}
                {button_limits_end.customerInvoice && <Menu.Item key="customerInvoice">客户开票情况表</Menu.Item>}
                {button_limits_end.customerInvoiceDetail &&
                    <Menu.Item key="customerInvoiceDetail">客户开票明细表</Menu.Item>}
                {button_limits_end.customerNoInvoice && <Menu.Item key="customerNoInvoice">客户未开票明细表</Menu.Item>}
                {button_limits_end.customerReturnQuery && <Menu.Item key="customerReturnQuery">客户回款查询</Menu.Item>}
                {button_limits_end.discountPoolInquiries &&
                    <Menu.Item key="discountPoolInquiries">折扣池明细查询</Menu.Item>}
                {button_limits_end.purchaseChart && <Menu.Item key="purchaseChart">采购报表</Menu.Item>}
                {button_limits_end.financeChart && <Menu.Item key="financeChart">财务报表</Menu.Item>}
                {button_limits_end.deffDeliveryOffer &&
                    <Menu.Item key="deffDeliveryOfferQuery">特殊发运申请查询</Menu.Item>}
                {button_limits_end.customerTaxReturn &&
                    <Menu.Item key="customerTaxReturnQuery">发票池退货关联表</Menu.Item>}
            </SubMenu>
            }

            {button_limits_end.systemXY && <SubMenu key="systemXY" title={<span>
              <Icon type='pay-circle'></Icon><span>事务管理-销售</span>
            </span>
            }>
                {button_limits_end.thingsOrder && <Menu.Item key="thingsOrder">订单管理</Menu.Item>}
                {button_limits_end.customer && <Menu.Item key="customer">客户管理</Menu.Item>}
                {button_limits_end.lower && <Menu.Item key="lower">下浮设置</Menu.Item>}
                {button_limits_end.dealer && <Menu.Item key="dealer">经销商信息维护</Menu.Item>}
                {button_limits_end.salesList && <Menu.Item key="salesList">销售明细报表</Menu.Item>}
                {button_limits_end.saleRank && <Menu.Item key="saleRank">销售排行</Menu.Item>}
            </SubMenu>
            }
            {button_limits_end.systemXX && <SubMenu key="systemXX" title={<span>
          <Icon type='database'></Icon><span>事务管理-库存</span>
        </span>}>
                {button_limits_end.stockControl && <Menu.Item key="stockControl">库存管理</Menu.Item>}
                {button_limits_end.warehouseInventoryQuery &&
                    <Menu.Item key="warehouseInventoryQuery">出入库记录查询</Menu.Item>}
                {button_limits_end.productCustomer && <Menu.Item key="productCustomer">其他产品管理</Menu.Item>}
                {button_limits_end.subStock && <Menu.Item key="subStock">子库存管理</Menu.Item>}
                {button_limits_end.saferStorageSet && <Menu.Item key="saferStorageSet">安全库存设置</Menu.Item>}
                {button_limits_end.stockControl && <Menu.Item key="storeOutInList">收发存报表</Menu.Item>}
            </SubMenu>
            }

            {button_limits_end.financialMgm && <SubMenu key="financialMgm" title={<span>
          <Icon type='pay-circle-o'></Icon><span>事务管理-财务</span>
        </span>}>
                {button_limits_end.salesQuery && <Menu.Item key="salesQuery">销售查询（收款类型）</Menu.Item>}
                {button_limits_end.receivedPayment && <Menu.Item key="receivedPayment">客户回款核销</Menu.Item>}
                {button_limits_end.payment && <Menu.Item key="payment">应付记录</Menu.Item>}
                {button_limits_end.verifying && <Menu.Item key="verifying">财务对账</Menu.Item>}
                {button_limits_end.otherInfo && <Menu.Item key="otherInfo">其他信息录入</Menu.Item>}
                {button_limits_end.verifyingDetail && <Menu.Item key="verifyingDetail">核销明细报表</Menu.Item>}
            </SubMenu>
            }

            {button_limits_end.survey && <Menu.Item key="survey" style={{background: '#efefef'}}>
                <Icon type='file'></Icon>
                <span>合作伙伴心声</span>
            </Menu.Item>}

            {button_limits_end.system && <SubMenu key="system" title={<span>
          <Icon type='setting'></Icon><span>系统设置</span>
        </span>}>
                {button_limits_end.homeSet &&
                    <Menu.Item key="homeSet"> <span>首页设置</span> </Menu.Item>}
                {button_limits_end.org && <Menu.Item key="org">组织架构</Menu.Item>}
                {button_limits_end.people && <Menu.Item key="people">人员管理</Menu.Item>}
                {button_limits_end.account && <Menu.Item key="account">账号管理</Menu.Item>}
                {button_limits_end.category && <Menu.Item key="category">产品分类</Menu.Item>}
                {button_limits_end.productSpec && <Menu.Item key="productSpec">产品规格</Menu.Item>}
                {button_limits_end.dictionary && <Menu.Item key="dictionary">数据字典</Menu.Item>}
                {button_limits_end.globalVar && <Menu.Item key="globalVar">全局变量</Menu.Item>}
                {/*  {button_limits_end.entrust && <Menu.Item key="entrust">委托书模板</Menu.Item>}*/}
                {button_limits_end.billingCtrl && <Menu.Item key="billingCtrl">开单管控配置</Menu.Item>}
                {button_limits_end.custItemList && <Menu.Item key="CustItem">客户专属物料</Menu.Item>}
            </SubMenu>
            }
        </Menu>
    }
}

Menus.propTypes = {
    data: PropTypes.array,
    collapsed: PropTypes.bool.isRequired,
    defaultSelectedKeys: PropTypes.array.isRequired,
};

export default Menus



// WEBPACK FOOTER //
// ./src/components/Menus.js